import { T } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'

export const NoChatSelected = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full grow text-content-muted">
      <div className="flex flex-col gap-2 items-center justify-center w-full sm:w-1/2">
        <SvgIcon
          name="message-text-circle"
          size="4x"
          className="text-content-muted"
        />
        <Text className="flex text-2xl font-semibold text-content-muted">
          <T
            id="Messaging.NoChatSelected.Title"
            defaultMessage="No conversation selected."
          />
        </Text>
        <Text className="text-sm text-center text-content-muted font-light">
          <T
            id="Messaging.NoChatSelected.Description"
            defaultMessage="Choose a conversation or start a new one."
          />
        </Text>
      </div>
    </div>
  )
}
